// extracted by mini-css-extract-plugin
export default {"answer":"RadioQuestion_answer__3ncCG","question":"RadioQuestion_question__bkXKn","text":"RadioQuestion_text__S+0up"};